var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import clsx from 'clsx';
export const Box = (props) => {
    const { className, type, gap, align } = props, otherProps = __rest(props, ["className", "type", "gap", "align"]);
    const newGap = gap || 0;
    const newClassName = clsx(`${type}-${newGap}`, { [`align_${align !== null && align !== void 0 ? align : ''}`]: align !== undefined }, className);
    return (React.createElement("div", Object.assign({}, otherProps, { className: newClassName })));
};
export const HBox = (props) => React.createElement(Box, Object.assign({ type: "HBox" }, props));
export const VBox = (props) => React.createElement(Box, Object.assign({ type: "VBox" }, props));
